export default "__VITE_ASSET__U6kzPi1___";